import type { Locale } from "date-fns/locale"

import type EditSkiPassViewModel from "@/queries/models/EditPass"
import type Resort from "@/queries/models/Resort"
import { formatStartDate } from "@/utils/dateUtils"
import { formatCurrency } from "@/utils/priceUtils"

type EditSummaryData = {
  destinationName: string
  startDateValue: string
  bookingLengthName: string
  orderTotalPriceText: string
}

const mapEditSummaryData = (
  data: EditSkiPassViewModel,
  resorts: Resort[] | undefined,
  locale: Locale
): EditSummaryData => {
  const resort = resorts?.find((r) => r.externalId === data.product.resortId)
  const price = data.price

  return {
    destinationName: resort?.name ?? "",
    startDateValue: formatStartDate(
      new Date(data.cartItem.arrivalDate),
      locale
    ),
    bookingLengthName: data.bookingLength.name,
    orderTotalPriceText: price
      ? formatCurrency(
          price.discountedPrice?.price ?? price.price,
          price.currencySymbol
        )
      : "-",
  }
}

export default mapEditSummaryData
